import React from 'react'
import NormalNotice from './NormalNotice'
import "../../stylings/notice.css"
import { Link } from 'react-router-dom'

const Notices = ({ loadNotice }) => {
    return (
        <section className='notice-section-wrapper'>
            <div className='container'>

                {/* Section Header */}
                <div className="notice-section-header">
                    <div className="notice-section-header-left">
                        <div className="notice-section-tag">
                            <i className="fa-solid fa-scroll"></i>
                            Notice Board
                        </div>
                        <h2 className="notice-section-title">Latest Notices &amp; Announcements</h2>
                        <p className="notice-section-subtitle">
                            Stay up to date with all school circulars, events and important information.
                        </p>
                    </div>
                    <div className="notice-section-header-right">
                        <Link to="/noticeall" className="notice-view-all-btn">
                            View All Notices <i className="fa-solid fa-arrow-right"></i>
                        </Link>
                    </div>
                </div>

                {/* Notice Cards */}
                <NormalNotice loadNotice={loadNotice} />

            </div>
        </section>
    )
}

export default Notices
